export const GET_REGISTEREDVENDORS_REQUEST = "GET_REGISTEREDVENDORS_REQUEST";
export const GET_REGISTEREDVENDORS_SUCCESS = "GET_REGISTEREDVENDORS_SUCCESS";
export const GET_REGISTEREDVENDORS_FAILURE = "GET_REGISTEREDVENDORS_FAILURE";